import axios from 'axios';
import CustomField from './custom-field.entity';
import CustomFieldPersist from './custom-field.persist';

export default class CustomFieldService {
  static getByProjectId(projectId: string): Promise<CustomField[]> {
    return axios.get(`/workitems/projects/${projectId}/custom-fields`)
      .then((response: any) => CustomField.ofList(response.data));
  }

  static delete(id: string): Promise<any> {
    return axios.delete(`/workitems/custom-fields/${id}`);
  }

  static save(customField: CustomFieldPersist): Promise<CustomField> {
    return axios.post('/workitems/custom-fields', customField)
      .then((response: any) => CustomField.of(response.data));
  }
}
